module.exports = __webpack_public_path__ + "media/images/athletes/2774-eaad7b95591184e892a48ab3a4cf4d76.png";